import React, { Component, useReducer, createRef } from "react";
import { connect } from "../../base/redux";
import { doLogin, forgotPassword } from "../actions";
import {
    isEmpty,
    isValidEmail,
    isLessThanMinLength,
} from "../../../utilities/validation";
import {
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalTitle,
    ModalTransition,
} from "@atlaskit/modal-dialog";
import { FieldTextStateless as TextField } from "@atlaskit/field-text";
import Button from "@atlaskit/button/standard-button";
import CrossIcon from "@atlaskit/icon/glyph/cross";
import { translate } from "../../base/i18n";

class LoginPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userName: "",
            password: "",
            formErrors: {
                userName: "",
                password: "",
            },
            isFormSubmitted: false,
            isJoin: false,
            serverError: "",
            passwordType: "password",
            showPassword: false,
            isForgotPasswordClicked: false,
            usernameForForgotPassword: "",
            invalidUserName: "",
        };

        this.onLoginFormSubmit = this.onLoginFormSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.isAllFieldsValid = this.isAllFieldsValid.bind(this);
        this.validateField = this.validateField.bind(this);
        this.onShowPasswordClick = this.onShowPasswordClick.bind(this);

        this.showPasswordRef = createRef();

        this.onForgotPasswordClick = this.onForgotPasswordClick.bind(this);
        this.onSubmitClick = this.onSubmitClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isLoginSuccess && this.props.loginSuccessCallback) {
            this.props.loginSuccessCallback();
        }
    }
    onChange(event) {
        let name = event.target.name;
        let value = event.target.value;

        if (name === "showPassword") {
            value = event.target.checked;
        }
        this.setState(
            { [name]: value, serverError: "", invalidUserName: "" },
            () => {
                if (this.state.isFormSubmitted) {
                    this.validateField(name, value);
                }
            }
        );
    }
    isAllFieldsValid() {
        let formErrors = this.state.formErrors;
        let isAllValid = true;
        for (let fieldName in formErrors) {
            this.validateField(fieldName, this.state[fieldName]);
            if (formErrors[fieldName].length > 0) {
                isAllValid = false;
            }
        }
        return isAllValid;
    }
    validateField(fieldName, fieldValue) {
        const { t } = this.props;
        let formErrors = this.state.formErrors;
        switch (fieldName) {
            case "userName":
                formErrors.userName = isEmpty(fieldValue)
                    ? t("loginPage.usernameEmpty")
                    : !isValidEmail(fieldValue)
                    ? t("loginPage.usernameInValid")
                    : "";
                break;
            case "password":
                formErrors.password = isEmpty(fieldValue)
                    ? t("loginPage.passwordEmpty")
                    : "";
                break;
        }
        this.setState({ formErrors });
    }

    onLoginFormSubmit(event) {
        event.preventDefault();
        this.setState({ isFormSubmitted: true });

        if (this.isAllFieldsValid()) {
            let requestBody = {
                username: this.state.userName,
                password: this.state.password,
                room_name: this.props.room,
                redirectURL: this.props._ssoConfRedirectUrl
            };
            this.props.dispatch(doLogin(requestBody));
            // this.props.loginSuccessCallback();
        }
    }
    onForgotPasswordClick() {
        this.setState({ isForgotPasswordClicked: true });
    }
    onSubmitClick() {
        const { t } = this.props;
        if (isEmpty(this.state.usernameForForgotPassword)) {
            this.setState({ invalidUserName: t("loginPage.usernameEmpty") });
            return;
        }
        if (!isValidEmail(this.state.usernameForForgotPassword)) {
            this.setState({ invalidUserName: t("loginPage.usernameInValid") });
            return;
        }
        forgotPassword(this.state.usernameForForgotPassword);
        this.setState({ isForgotPasswordClicked: false });
        if (this.props.onModalClose) {
            this.props.onModalClose();
        }
    }
    onShowPasswordClick() {
        let inputType = this.showPasswordRef.current.props.type;
        if (inputType === "password") {
            this.setState({ passwordType: "text" });
        } else {
            this.setState({ passwordType: "password" });
        }
    }

    render() {
        const { t } = this.props;
        return (
            <>
                {this.state.isForgotPasswordClicked ? (
                    <>
                        <ModalHeader>
                            <ModalTitle>Forgot Password</ModalTitle>
                            <Button
                                appearance="link"
                                onClick={this.props.onModalClose}
                            >
                                <CrossIcon label="Close Modal" />
                            </Button>
                        </ModalHeader>
                        {/* <TextField
                            autoFocus = { true }
                            type="text"
                            className="input-control"
                            placeholder="user@domain.net"
                            name="usernameForForgotPassword"
                            value={this.state.userNameForForgotPassword}
                            onChange={this.onChange} /> */}
                        <ModalBody>
                            <TextField
                                autoFocus={true}
                                className="input-control"
                                compact={false}
                                label={t("dialog.enterEmail")}
                                name="usernameForForgotPassword"
                                onChange={this.onChange}
                                placeholder={t("dialog.enterEmailPlaceholder")}
                                shouldFitContainer={true}
                                type="text"
                                value={this.state.userNameForForgotPassword}
                            />
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                appearance="primary"
                                onClick={this.onSubmitClick}
                            >
                                Submit
                            </Button>
                        </ModalFooter>
                        {/* <div>
                            <button
                                className="login-popup-submit-btn input-control"
                                onClick={this.onSubmitClick}
                            >
                                Submit
                            </button>
                        </div> */}
                        {this.state.invalidUserName && (
                            <span className="error">
                                {this.state.invalidUserName}
                            </span>
                        )}
                    </>
                ) : (
                    <>
                        <form onSubmit={this.onLoginFormSubmit}>
                            <ModalHeader>
                                <ModalTitle>Log In</ModalTitle>
                                <Button
                                    appearance="link"
                                    onClick={this.props.onModalClose}
                                >
                                    <CrossIcon label="Close Modal" />
                                </Button>
                            </ModalHeader>
                            <ModalBody>
                                {this.state.serverError && (
                                    <span className="error">
                                        {this.state.serverError}
                                    </span>
                                )}
                                <TextField
                                    type="text"
                                    name="userName"
                                    className="input-control"
                                    value={this.state.userName}
                                    onChange={this.onChange}
                                    autoFocus={true}
                                    compact={false}
                                    label={t("dialog.enterEmail")}
                                    placeholder={t(
                                        "dialog.enterEmailPlaceholder"
                                    )}
                                    shouldFitContainer={true}
                                />
                                {this.state.isFormSubmitted &&
                                    this.state.formErrors.userName && (
                                        <span className="error">
                                            {this.state.formErrors.userName}
                                        </span>
                                    )}
                                <div className="show_password">
                                    <div className="button-outer">
                                        <label className="switch">
                                            <input
                                                checked={
                                                    this.state.showPassword
                                                }
                                                type="checkbox"
                                                name="showPassword"
                                                value={this.state.showPassword}
                                                onChange={this.onChange}
                                                onClick={
                                                    this.onShowPasswordClick
                                                }
                                            />
                                            <span className="slider round"></span>
                                            <span className="button-title"></span>
                                        </label>
                                    </div>
                                    <TextField
                                        type={this.state.passwordType}
                                        name="password"
                                        className="input-control"
                                        label={t("dialog.enterPassword")}
                                        placeholder={t(
                                            "dialog.enterPasswordPlaceholder"
                                        )}
                                        compact={false}
                                        value={this.state.password}
                                        onChange={this.onChange}
                                        ref={this.showPasswordRef}
                                        shouldFitContainer={true}
                                    />
                                </div>
                                {this.state.isFormSubmitted &&
                                    this.state.formErrors.password && (
                                        <span className="error">
                                            {this.state.formErrors.password}
                                        </span>
                                    )}
                            </ModalBody>
                            <ModalFooter>
                                <div>
                                    <Button type="submit" appearance="primary">
                                        GO
                                    </Button>
                                </div>
                                <div>
                                    <a
                                        href="#"
                                        onClick={this.onForgotPasswordClick}
                                    >
                                        Forgot password?
                                    </a>
                                </div>
                            </ModalFooter>
                        </form>
                    </>
                )}
            </>
        );
    }
}

function _mapStateToProps(state: Object) {
    const { ssoConf } = state['features/base/config'];
    return {
        isLoginSuccess: state["features/welcome"].isLoginSuccess,
        isLoginFailure: state["features/welcome"].isLoginFailure,
        errorMessage: state["features/welcome"].errorMessage,
        _ssoConfRedirectUrl: ssoConf?.redirect_uri
    };
}

export default translate(connect(_mapStateToProps)(LoginPage));
